// extracted by mini-css-extract-plugin
module.exports = {"container":"CollectionStatus_container__3MC92","tracking_status":"CollectionStatus_tracking_status__1gbDC","customer_logo":"CollectionStatus_customer_logo__3scBy"};